import { useAtomValue } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

import { editDrawerState } from '~/state/settings_practitioners/atoms';

type CurrentProps = {
  isOpen: boolean;
  isPrivilege?: boolean | null;
  practitionerId?: string | null;
};

export const useDrawerAnimation = () => {
  const state = useAtomValue(editDrawerState);
  const [currentProps, setCurrentProps] = useState<CurrentProps>({
    isOpen: state.isOpen,
    isPrivilege: state.isPrivilege,
    practitionerId: state.practitionerId,
  });

  const handleTransitionEnd = useCallback(() => {
    setCurrentProps({
      isOpen: state.isOpen,
      isPrivilege: state.isPrivilege,
      practitionerId: state.practitionerId,
    });
  }, [state.isOpen, state.isPrivilege, state.practitionerId]);

  useEffect(() => {
    setCurrentProps((_state) => ({ ..._state, isOpen: false }));
  }, [state.isPrivilege, state.practitionerId]);

  useEffect(() => {
    if (state.isOpen) {
      setCurrentProps({
        isOpen: state.isOpen,
        isPrivilege: state.isPrivilege,
        practitionerId: state.practitionerId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isOpen]);

  return { currentProps, handleTransitionEnd };
};
